const state = {
  status: 404,
  message: null
};

const getters = {};

const actions = {
  updateState ({ commit }, { status, message }) {
    commit('updateState', { status, message });
  }
};

const mutations = {
  updateState (state, value) {
    state = Object.assign(state, value);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
